module.exports = __webpack_public_path__ + "static/covid19-tracker-153377304adf5c2c7bf723a8e9fab44f.jpg";